import styled from 'styled-components'

export const NotifyAnimation = styled.div`
  .circle,
  .circle::before {
    content: ' ';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transition: all 0.3s;
    background-color: var(--green-dark);
  }

  .circle::before {
    animation: move 2s infinite;
    position: absolute;
  }

  @keyframes move {
    50% {
      transform: scale(2);
      opacity: 0;
    }
    100% {
      transform: scale(2);
      opacity: 0;
    }
  }
`
